import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { RideRequestType } from './ride-request-type';

@inheritSerialization(AbstractModel)
export class RideMonitoringAlert extends AbstractModel {
  @autoserialize
  operationAlertId: number;

  @autoserialize
  riderName: string;

  @autoserialize
  driverName: string;

  @autoserialize
  transitProgramCode: string;

  @autoserialize
  alertText: string;

  @autoserializeAs(Date)
  pickupDate: Date;

  @autoserialize
  timeZone: string;

  @autoserialize
  rideStatus: string;

  @autoserializeAs(Date)
  lastStatusUpdateDate: Date;

  @autoserialize
  reservationId: number;

  @autoserialize
  rideRequestId: number;

  @autoserialize
  riderPhoneNumber: string;

  @autoserializeAs(Date)
  operationsAlertCreatedDate: Date;

  @autoserializeAs(RideRequestType)
  rideRequestType: RideRequestType;

  static OnSerialized(instance: RideMonitoringAlert, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.pickupDate)) {
      json.pickupDate = DateUtil.serializeDate(instance.pickupDate);
    }

    if (!isNullOrUndefined(instance.lastStatusUpdateDate)) {
      json.lastStatusUpdateDate = DateUtil.serializeDate(instance.lastStatusUpdateDate);
    }

    if (!isNullOrUndefined(instance.operationsAlertCreatedDate)) {
      json.operationsAlertCreatedDate = DateUtil.serializeDate(instance.operationsAlertCreatedDate);
    }
  }

  static OnDeserialized(instance: RideMonitoringAlert, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['pickupDate'])) {
      instance.pickupDate = DateUtil.deserializeDate(json['pickupDate']);
    }

    if (!isNullOrUndefined(json['lastStatusUpdateDate'])) {
      instance.lastStatusUpdateDate = DateUtil.deserializeDate(json['lastStatusUpdateDate']);
    }

    if (!isNullOrUndefined(json['operationsAlertCreatedDate'])) {
      instance.operationsAlertCreatedDate = DateUtil.deserializeDate(json['operationsAlertCreatedDate']);
    }
  }
}
